var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.url + '#_'}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }